import React, { PureComponent, Fragment } from 'react';
import { I18n } from 'aws-amplify';
import { Link } from 'react-router-dom';
import WhatifWrapper from '../components/WhatifWrapper';

import SubHeader from '../components/SubHeader';

import PageSuccess from '../components/PageSuccess';

class PartnerProfileSuccess extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        return (
            <WhatifWrapper>
                <SubHeader />
                <PageSuccess>
                    <Fragment>
                        <h2>Parabéns</h2>
                        <p>Suas informações foram cadastradas com sucesso! Gostaria de ver o briefing das marcas para enviar ideias?</p>

                        <p>
                            <Link>Depois</Link>
                            <Link>SIM, QUERO!</Link>
                        </p>
                    </Fragment>
                </PageSuccess>
            </WhatifWrapper>
        );
    }
}

export default PartnerProfileSuccess;
